main
{
	padding: 0;
}

.hero
{
	display: grid;
	margin-top: map-get($spacers, 3);
	grid-gap: map-get($spacers, 3);
	grid-template-columns: repeat(2, 1fr);

	@include media-breakpoint-up(md)
	{
		margin-top: map-get($spacers, 4);
		grid-gap: map-get($spacers, 4);
		grid-template-columns: 6fr 4fr;
	}

	&__primary
	{
		aspect-ratio: 767/441;
		grid-column: span 2;

		@include media-breakpoint-up(md)
		{
			aspect-ratio: unset;
			grid-column: unset;
			grid-row: span 2;
			border-radius: 0 $border-radius-lg $border-radius-lg 0;
		}
	}

	&__secondary
	{
		aspect-ratio: 379/222;
		border-radius: $border-radius-lg 0 0 $border-radius-lg;

		@include media-breakpoint-down(md)
		{
			&--1
			{
				border-radius: 0 $border-radius-lg $border-radius-lg 0;
			}
		}

		@include media-breakpoint-up(md)
		{
			aspect-ratio: 762/354;
			grid-row: span 1;
		}
	}

	&__unit
	{
		position: relative;
		overflow: hidden;
	}

	&__img
	{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__txt
	{
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		justify-content: flex-end;
		text-align: center;
		color: #fff;
		left: 0;
		margin-left: 2.62vw;

		@include media-breakpoint-up(md)
		{
			margin-left: 1.96vw;
		}
	}

	&__title
	{
		line-height: 1;
	}

	&__btn
	{
		border: 0;
		font-weight: $font-weight-base;
		border-radius: $border-radius-pill;
		font-size: 3vw;
		padding: 0 1.96vw;

		@include media-breakpoint-up(md)
		{
			font-size: 2.3vw;
		}
	}
}

.squares,
.big-squares
{
	@include media-breakpoint-up(md)
	{
		--bs-gutter-x: #{map-get($spacers, 4)} !important;
		--bs-gutter-y: #{map-get($spacers, 4)} !important;
	}

	.card-footer-overlay
	{
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		margin: 0;
		border-radius: 0;
	}
}

.squares
{
	.card
	{
		.ratio
		{
			--bs-aspect-ratio: calc(383 / 335 * 100%);
		}

		.card-footer-overlay
		{
			background-color: rgba($white, 0.9);
		}
	}
}

.big-squares
{
	.card
	{
		.ratio
		{
			--bs-aspect-ratio: calc(370 / 552 * 100%);
		}

		.card-footer-overlay
		{
			background-color: $purple;
			color: #fff;
		}
	}
}

.card
{
	overflow: hidden;
}

.carousel
{
	&__container
	{
		display: grid;
		width: 100%;
		grid-gap: map-get($spacers, 3);
		grid-template-columns: repeat(3, 100%);

		@include media-breakpoint-down(lg)
		{
			scroll-snap-type: x mandatory;
			overflow-x: auto;
			scroll-behavior: smooth;
			-webkit-overflow-scrolling: touch;
			scrollbar-width: none;

			&::-webkit-scrollbar
			{
				display: none;
			}
		}

		@include media-breakpoint-up(lg)
		{
			grid-gap: map-get($spacers, 4);
			grid-template-columns: repeat(3, 1fr);
		}
	}

	&__item
	{
		@include media-breakpoint-down(lg)
		{
			scroll-snap-align: center;
		}
	}
}

.carousel__dots
{
	list-style: none;
	display: flex;
	justify-content: center;
	padding-left: 0;
	margin: map-get($spacers, 3) 0;

	@include media-breakpoint-up(lg)
	{
		margin: map-get($spacers, 4) 0;
	}

	li
	{
		position: relative;
		flex: 0 1 auto;
		width: 14px;
		height: 14px;
		background: $gray-200;
		border-radius: 50%;
		margin-right: map-get($spacers, 2);
		margin-left: map-get($spacers, 2);
		cursor: pointer;

		&.active
		{
			background: $black;
		}

		// Use pseudo classes to increase the hit area by 10px on top and bottom.

		&::before,
		&::after
		{
			position: absolute;
			left: 0;
			display: inline-block;
			width: 100%;
			height: 10px;
			content: "";
		}

		&::before
		{
			top: -10px;
		}

		&::after
		{
			bottom: -10px;
		}
	}
}

.testimonial
{
	display: grid;
	grid-template-rows: min-content 1fr min-content;
	justify-items: center;
}

@include media-breakpoint-down(lg)
{
	.readClamp:not(.readClamp--open) .homeText p
	{
		display: inline;
	}
}

.homeText
{
	@include media-breakpoint-up(lg)
	{
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap: map-get($spacers, 4);
	}
}